import { render, staticRenderFns } from "./monitor-groups-manage.vue?vue&type=template&id=1d784f58&scoped=true&slot=footer"
import script from "./monitor-groups-manage.vue?vue&type=script&lang=js"
export * from "./monitor-groups-manage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d784f58",
  null
  
)

export default component.exports